import { render } from "./rental.vue?vue&type=template&id=9fcd2fdc&scoped=true"
import script from "./rental.vue?vue&type=script&lang=js"
export * from "./rental.vue?vue&type=script&lang=js"

import "./rental.vue?vue&type=style&index=0&id=9fcd2fdc&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fcd2fdc"]])

export default __exports__